import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Log } from "ng2-logger";

import { TableConfig, TableConfigUtils } from "@app/shared/util/table-config.utils";
import { ToolRequest } from "@models/toolRequests.model";
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";

@Component({
    selector: 'app-tool-requests-lines-table',
    templateUrl: './tool-requests-lines-table.component.html',
    styleUrls: ['./tool-requests-lines-table.component.scss']
})
export class ToolRequestLinesTableComponent implements OnChanges {
    _logger = Log.create(ToolRequestLinesTableComponent.name);

    @Input() toolRequests: ToolRequest[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() statusFilters = [];
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;
    @Input() isMaterial = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();
    @Output() processClick = new EventEmitter<any>();
    @Output() resumeClick = new EventEmitter<any>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['toolRequests'] && this.toolRequests.length > 0) {
            this.toolRequests = TableConfigUtils.addColorToToolRequestsByPriority(this.toolRequests);
        }
    }

    onPageChange(tableConfig: TableConfig) {
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this.filterChange.emit(tableConfig);
    }

    process(toolRequest) {
        this.processClick.emit(toolRequest);
    }

    resume(toolRequest) {
        this.resumeClick.emit(toolRequest);
    }

    shouldRenderProcess(toolRequest) {
        return toolRequest.status === ToolRequestStatus.NEW;
    }

    shouldRenderResume(toolRequest) {
        return toolRequest.status === ToolRequestStatus.WAITING_FOR_APPROVAL;
    }
}
